import { render, createVNode } from "vue";

import loginPage from "./loginPage.vue";

export default function (url,name) {
    const mountNode = document.createElement("div");
    const hideNotice = () => {
        // document.body.removeChild(mountNode);
    };
    const app = createVNode(loginPage, {target:mountNode,name: name,url});
    render(app, mountNode);
    document.body.appendChild(mountNode);
    hideNotice();
}